import $ from 'jquery';
import { App } from './App.js';

import '@mockup/plugins/jquery.fancybox';
import '@mockup/plugins/jquery.rangeslider';
import '@mockup/plugins/z.7.cleaver';
import '@mockup/plugins/z.8.bootstrap-datepicker';
import '@mockup/plugins/z.9.bootstrap-datepicker-range';
import '@mockup/plugins/IP.Validation';
import '@mockup/plugins/jquery.hash';

import '@mockup/charts';

// Add an alias to the App, if we need to call App from the outside:
global.$ = global.jQuery = window.$ = window.jQuery = $;
global.App = window.App = App;

window.GoogleAnalyticsEvent = (kategori, action, label, value) => window.ga('send', 'event', kategori, action, label, value);
window.GoogleAnalyticsEvent = (kategori, action, label) => window.ga('send', 'event', kategori, action, label);

window.isMobileDevice = false;

$.fn.filterByData = function (prop, val) {
    return this.filter(function () {
        return $(this).data(prop) == val;
    });
};
